import { APICore } from "./apiCore";

const api = new APICore();

// category
function addCurrencyApi(params: {
  currency_name: string | null;
  currency_flag: string | null;
  currency_code: string | null;
  currency_rate: string | null;
}) {
  const baseUrl = "/currency";
  return api.create(`${baseUrl}`, params);
}

function getCurrencyApi() {
  const baseUrl = "/currency";
  return api.get(`${baseUrl}`, {});
}

function updateCurrencyApi(
  id: number,
  params: {
    currency_name: string | null;
    currency_flag: string | null;
    currency_code: string | null;
    currency_rate: string | null;
    isActive: any | null;
  }
) {
  const baseUrl = `/currency/${id}`;
  
  
  return api.update(`${baseUrl}`, params);
}

function deleteCurrencyApi(id: number) {
  const baseUrl = `/currency/${id}`;
  return api.delete(`${baseUrl}`);
}

export { addCurrencyApi, getCurrencyApi, updateCurrencyApi, deleteCurrencyApi };
